<template>
  <div>
    <div class="row">
      <div :class="['col_12', {'loading_overlay': loading}]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('package_name')}]">
                  <label>{{ $t('sidebar.packageManagement.package_name') }}</label>
                  <input type="text" class="form_global" v-model="form.package_name">
                  <v-errors :errors="errorFor('package_name')" />
                </div>
              </div>

              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('package_type')}]">
                  <label>{{ $t('sidebar.packageManagement.package_type') }}</label>
                  <select v-model="form.package_type" class="form_global">
                    <option value="">{{ $t('sidebar.packageManagement.select_package_type') }}</option>
                    <option value="one-time">{{ $t('sidebar.packageManagement.one_time_package') }}</option>
                    <option value="subscription">{{ $t('sidebar.packageManagement.subscription_package') }}</option>
                  </select>
                  <v-errors :errors="errorFor('package_type')" />
                </div>
              </div>

              <div class="col_4">
                <div :class="['form-group', {'has_error': errorFor('classification')}]">
                  <label>{{ $t('sidebar.packageManagement.classification') }}</label>
                  <select v-model="form.classification" class="form_global">
                    <option value="">{{ $t('sidebar.packageManagement.select_classification') }}</option>
                    <option value="general-product">{{ $t('sidebar.packageManagement.general_product') }}</option>
                    <option value="limited-time-product">{{ $t('sidebar.packageManagement.limited_time_product') }}</option>
                  </select>
                  <v-errors :errors="errorFor('classification')" />
                </div>
              </div>

              <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('selectedServices')}]">
                  <label>{{ $t('sidebar.packageManagement.connection_service') }}</label>
                  <ul>
                    <li class="mr_20 mb_10" v-for="(service, key) in connection_services" :key="'service' + service.id">
                      <div class="form_checkbox">
                        <input type="checkbox" :id="'service' + key" :value="service.id" v-model="form.selectedServices">
                        <label :for="'service' + key" checked>{{ service.name }}</label>
                      </div>
                    </li>
                  </ul>
                  <v-errors :errors="errorFor('selectedServices')" />
                </div>
              </div>

              <div class="col_3">
                  <div :class="['form-group', {'has_error': errorFor('status')}]">
                      <label>{{ $t('common.status') }}</label>
                      <div class="form_inline">
                          <div class="form_radio">
                              <input type="radio" id="active" value="1" v-model="form.status">
                              <label for="active">{{ $t('common.active') }}</label>
                          </div>
                          <div class="form_radio">
                              <input type="radio" id="inactive" value="0" v-model="form.status">
                              <label for="inactive">{{ $t('common.inactive') }}</label>
                          </div>
                      </div>
                      <v-errors :errors="errorFor('status')" />
                  </div>
              </div>

              <div class="col_6" v-if="form.classification === 'general-product'">
                <div :class="['form-group', {'has_error': errorFor('service_months')}]">
                  <label>{{ $t('sidebar.packageManagement.service_period_month') }}</label>
                  <input type="text" class="form_global" v-model="form.service_months">
                  <v-errors :errors="errorFor('service_months')" />
                </div>
              </div>
              <div class="col_3" v-if="form.classification === 'limited-time-product'">
                <div :class="['form-group', {'has_error': errorFor('service_start')}]">
                  <label>{{ $t('sidebar.packageManagement.service_start_date') }}</label>
                  <datepicker v-model="form.service_start" 
                              position="left" 
                              :format="'yyyy-MM-dd'"
                              @blur="form.service_start=dateFormat(form.service_start, 'YYYY-MM-DD')"
                              autoApply
                              :enableTimePicker="false" 
                              :clearable="true">
                  </datepicker>
                  <v-errors :errors="errorFor('service_start')" />
                </div>
              </div>
              <div class="col_3" v-if="form.classification === 'limited-time-product'">
                <div :class="['form-group', {'has_error': errorFor('service_end')}]">
                  <label>{{ $t('sidebar.packageManagement.service_end_date') }}</label>
                  <datepicker v-model="form.service_end" 
                              position="left" 
                              :format="'yyyy-MM-dd'"
                              @blur="form.service_end=dateFormat(form.service_end, 'YYYY-MM-DD')"
                              autoApply
                              :enableTimePicker="false" 
                              :clearable="true">
                  </datepicker>
                  <v-errors :errors="errorFor('service_end')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('price')}]">
                  <label>{{ $t('sidebar.packageManagement.price') }}</label>
                  <input type="text" class="form_global" v-model="form.price">
                  <v-errors :errors="errorFor('price')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('discount_price')}]">
                  <label>{{ $t('sidebar.packageManagement.discount_price') }}</label>
                  <input type="text" class="form_global" v-model="form.discount_price" @input="changeDiscount()" min="0">
                  <v-errors :errors="errorFor('discount_price')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('discount_percentage')}]">
                  <label>{{ $t('sidebar.packageManagement.discount_percentage') }}</label>
                  <input type="text" class="form_global" v-model="form.discount_percentage" @input="changeDiscountPercentage()" min="0">
                  <v-errors :errors="errorFor('discount_percentage')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('delivery_fee')}]">
                  <label>{{ $t('sidebar.packageManagement.delivery_fee') }}</label>
                  <input type="text" class="form_global" v-model="form.delivery_fee">
                  <v-errors :errors="errorFor('delivery_fee')" />
                </div> 
              </div>
            </div>

            <div class="row">
              <div class="col_6">
                <div :class="['form-group', {'has_error': errorFor('product_details')}]">
                  <label>{{ $t('sidebar.packageManagement.product_details') }}</label>
                  <text-editor-component 
                      :id="'product_details'" 
                      :existingData="form.product_details ? form.product_details : ''" 
                      @change="changeEditorValue"
                  />
                  <v-errors :errors="errorFor('product_details')" />
                </div>
              </div>
              <div class="col_6">
                <div :class="['form-group', {'has_error': errorFor('memos')}]">
                  <label>{{ $t('common.memo') }}</label>
                  <text-editor-component 
                      :id="'memos'" 
                      :existingData="form.memos ? form.memos : ''" 
                      @change="changeEditorValue"
                  />
                  <v-errors :errors="errorFor('memos')" />
                </div>
              </div>
            </div>
            <div class="d_flex_end form_action_btn">
              <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
              <button class="btn btn_blue ml_10" :disabled="loading" @click.prevent="submit">{{ $t('common.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextEditorComponent from "@/components/TextEditorComponent";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
export default {
  components: { TextEditorComponent, Datepicker },
  data() {
    return {
      title: this.$t('sidebar.packageManagement.addPackage'),
      cancelRouteName: 'package_list',
      subjects: [],
      connection_services: [],
      form: {
        package_type: 'one-time',
        classification: 'general-product',
        package_name: "",
        service_months: '',
        service_start: '',
        service_end: '',
        price: '',
        discount_price: '',
        discount_percentage: '',
        status: 1,
        delivery_fee: '',
        product_details: '',
        memos: '',
        selectedServices: [],
        type: 'package'
      }
    }
  },
  created() {
    this.axios.get('/subjects')
        .then(response => {
          this.subjects = response.data.data;
        });

    this.axios.get('/connection-services')
      .then(response => {
        this.connection_services = response.data.data;
      });

    if (this.$route.name === 'package_edit') {
      this.axios.get('/packages/'+this.$route.params.id)
          .then((response) => {
            let editPackageData = response.data.data;

            this.form.subject_id = editPackageData.subject ? editPackageData.subject.id : '';
            this.form.package_type = editPackageData.package_type
            this.form.classification = editPackageData.classification
            this.form.package_name = editPackageData.package_name
            this.form.service_months = editPackageData.service_months
            this.form.service_start = editPackageData.service_start
            this.form.service_end = editPackageData.service_end
            this.form.price = editPackageData.price
            this.form.discount_price = editPackageData.discount_price
            this.form.discount_percentage = editPackageData.discount_percentage
            this.form.status = editPackageData.status
            this.form.delivery_fee = editPackageData.delivery_fee
            this.form.product_details = editPackageData.product_details
            this.form.memos = editPackageData.memos

            this.form.selectedServices = []
            editPackageData.services.map((i) => this.form.selectedServices.push(i.service_id))
          })
      this.title = 'Edit Package';
    }
  },
  watch:{
    
  },
  methods: {
    changeEditorValue(editorId, data){
      this.form[editorId] = data
    },
    dateFormat(e, format){
        if(e){
            return moment(e).format(format)
        }
        return null
    },
    changeDiscount(){
      let discountPercentData = 0;
      let price = this.form.price;
      let discountPrice = Number(this.form.discount_price);

      if(price && discountPrice > 0){
        discountPercentData = (discountPrice * 100) / Number(price);
      }
      
      this.form.discount_percentage = discountPercentData.toFixed(2);
    },

    changeDiscountPercentage(){
      let discountData = 0;
      let price = this.form.price;
      let discountPercentage = Number(this.form.discount_percentage);

      if(price && discountPercentage > 0){
        discountData = Number(discountPercentage / 100) * Number(price);
      }

      this.form.discount_price = discountData.toFixed(2);
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      if(this.form.classification === 'limited-time-product')
        this.form.service_months = ''

      if(this.form.classification === 'general-product') {
        this.form.service_start = ''
        this.form.service_end = ''
      }

      if (this.$route.name === 'package_edit') {
        this.axios.patch('/packages/'+this.$route.params.id, this.form)
            .then(() => {
              this.$router.push({name: 'package_list'});
              this.showSuccessMsg(this.$t('common.updateSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      } else {
        this.axios.post('/packages', this.form)
            .then(() => {
              this.$router.push({name: 'package_list'});
              this.showSuccessMsg(this.$t('common.addSuccess'))
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
      }
    }
  }
}
</script>
<style scoped>
  .dp__menu{
    top: 196px;
  }
</style>
